import React, { useEffect, useState } from "react";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
  Divider,
  Switch,
  Box,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DatePicker from "@mui/lab/DatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import api from "../../../components/services/api";
import moment from "moment";
import { useFormik } from "formik";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { useHistory } from "react-router";
import TimePicker from "@mui/lab/TimePicker";

export default function DialogEditShip(props) {
  //   const classes = useStyles();
  const EmpId = localStorage.getItem("EmpId");
  const history = useHistory();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [BargeList, setBargeList] = useState([]);
  const [LocationList, setLocationList] = useState([]);
  const [TugList, setTugList] = useState([]);
  const [Submitting, setSubmitting] = useState(false);
  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      id: props?.dataprops?.id,
      etdIn: props?.dataprops?.row?.ETDIn,
      etaIn: props?.dataprops?.row?.ETAIn,
      etdOut: props?.dataprops?.row?.ETDOut,
      etaOut: props?.dataprops?.row?.ETAOut,
      remarkIn: props?.dataprops?.row?.RemarkIn,
      remarkOut: props?.dataprops?.row?.RemarkOut,
      StatusIn: props?.dataprops?.row?.StatusIn,
      StatusOut: props?.dataprops?.row?.StatusOut
    },
    onSubmit: (values) => {
      const ModId = EmpId;
      setSubmitting(true);
      setTimeout(() => {
        const data = {
          id: values.id ? values.id : props?.dataprops?.id,
          etaIn: values.etaIn
            ? moment(values.etaIn).format("YYYY-MM-DD HH:mm")
            : moment(props?.dataprops?.row?.ETAIn).format("YYYY-MM-DD HH:mm"),
          etdIn: values.etdIn
            ? moment(values.etdIn).format("YYYY-MM-DD HH:mm")
            : moment(props?.dataprops?.row?.ETDIn).format("YYYY-MM-DD HH:mm"),
          etaOut: values.etaOut
            ? moment(values.etaOut).format("YYYY-MM-DD HH:mm")
            : moment(props?.dataprops?.row?.ETAOut).format("YYYY-MM-DD HH:mm"),
          etdOut: values.etdOut
            ? moment(values.etdOut).format("YYYY-MM-DD HH:mm")
            : moment(props?.dataprops?.row?.ETDOut).format("YYYY-MM-DD HH:mm"),
          ModId,
          remarkIn: values.remarkIn,
          remarkOut: values.remarkOut,
          StatusIn: values?.StatusIn,
          StatusOut: values?.StatusOut
        };
        api
          .post("api/ship/update", data)
          .then((respose) => {
            handleClose();
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire("สำเร็จ!", "แก้ไขสำเร็จ !", "success").then(
                (result) => {
                  if (result.isConfirmed) {
                    // console.log(result.isConfirmed);
                    // console.log(result);
                    props.ShipScheduleList()
                    handleClose();
                  }
                }
              );
            });
          })
          .catch((err) => {
            console.log(err);
          });

        setSubmitting(false);
      }, 400);
    },
  });

  const handleClose = () => {
    props.DialogEditClose(false);
    formik.setFieldValue("etdIn", "");
    formik.setFieldValue("etaIn", "");
    formik.setFieldValue("etdOut", "");
    formik.setFieldValue("etaOut", "");
    formik.setFieldValue("id", "");
    props.onSuccess();
  };

  useEffect(() => { }, []);

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={props.DialogEdit}
        onClose={() => handleClose()}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg"
        fullWidth={true}
      >
        <DialogTitle id="responsive-dialog-title">
          {
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Edit Ship Schedule
            </Typography>
          }
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              backgroundColor: "#30318D",
              padding: 1,
              flexDirection: "row",
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 3,
              alignItems: 'center'
            }}
          >
            <h5 style={{ color: "white" }}>
              {props?.dataprops?.row?.LocFrom} - {props?.dataprops?.row?.LocTo}
            </h5>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ display: "flex", alignItems: "center", marginRight: "20px" }}>
                <h5 style={{ color: "white" }}>OMIT</h5>
                <Switch checked={formik.values?.StatusIn} onChange={e => formik.setFieldValue("StatusIn", e.target.checked)}/>
                <h5 style={{ color: "white" }}>OPEN</h5>
              </div>
              <h5 style={{ color: "white" }}>
                #{props?.dataprops?.row?.VoyageIn}
              </h5>
            </div>

          </Box>

          <Grid container spacing={3}>
            <Grid item xs={12} sm={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd MMM yyyy"
                  name="ETD DATE"
                  value={
                    formik.values.etdIn
                      ? formik.values.etdIn
                      : props?.dataprops?.row?.ETDIn
                  }
                  onChange={(newValue) =>
                    formik.setFieldValue("etdIn", newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="ETD DATE"
                      style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                        width: "100%",
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12} md={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <TimePicker
                  label="ETD TIME"
                  value={
                    formik.values.etdIn
                      ? formik.values.etdIn
                      : props?.dataprops?.row?.ETDIn
                  }
                  onChange={(newValue) =>
                    formik.setFieldValue("etdIn", newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                        width: "100%",
                      }}
                      {...params}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd MMM yyyy"
                  name="ETA DATE"
                  value={
                    formik.values.etaIn
                      ? formik.values.etaIn
                      : props?.dataprops?.row?.ETAIn
                  }
                  onChange={(newValue) =>
                    formik.setFieldValue("etaIn", newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="ETA DATE"
                      style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                        width: "100%",
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <TimePicker
                  label="ETA TIME"
                  value={
                    formik.values.etaIn
                      ? formik.values.etaIn
                      : props?.dataprops?.row?.ETAIn
                  }
                  onChange={(newValue) =>
                    formik.setFieldValue("etaIn", newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                        width: "100%",
                      }}
                      {...params}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>

          <TextField
            id="outlined-multiline-static"
            label="Remark"
            multiline
            sx={{ width: '100%' }}
            rows={2}
            value={formik.values.remarkIn}
            onChange={(e) =>
              formik.setFieldValue("remarkIn", e.target.value)
            }
          />

          <Divider sx={{ margin: "30px 0px 30px 0px" }} />

          <Box sx={{
            backgroundColor: "#80C340",
            padding: 1,
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 3,
            alignItems: "center"
          }}>
            <h5 style={{ color: "white" }}>
              {props?.dataprops?.row?.LocTo} - {props?.dataprops?.row?.LocFrom}
            </h5>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ display: "flex", alignItems: "center", marginRight: "20px" }}>
                <h5 style={{ color: "white" }}>OMIT</h5>
                <Switch checked={formik.values?.StatusOut} onChange={e => formik.setFieldValue("StatusOut", e.target.checked)}/>
                <h5 style={{ color: "white" }}>OPEN</h5>
              </div>
              <h5 style={{ color: "white" }}>
                #{props?.dataprops?.row?.VoyageOut}
              </h5>
            </div>
          </Box>

          <Grid container spacing={3}>
            <Grid item xs={12} sm={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd MMM yyyy"
                  name="ETD DATE"
                  value={
                    formik.values.etdOut
                      ? formik.values.etdOut
                      : props?.dataprops?.row?.ETDOut
                  }
                  onChange={(newValue) =>
                    formik.setFieldValue("etdOut", newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="ETD DATE"
                      style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                        width: "100%",
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <TimePicker
                  label="ETD TIME"
                  value={
                    formik.values.etdOut
                      ? formik.values.etdOut
                      : props?.dataprops?.row?.ETDOut
                  }
                  onChange={(newValue) =>
                    formik.setFieldValue("etdOut", newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                        width: "100%",
                      }}
                      {...params}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd MMM yyyy"
                  name="ETA DATE"
                  value={
                    formik.values.etaOut
                      ? formik.values.etaOut
                      : props?.dataprops?.row?.ETAOut
                  }
                  onChange={(newValue) =>
                    formik.setFieldValue("etaOut", newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="ETA DATE"
                      style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                        width: "100%",
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <TimePicker
                  label="ETA TIME"
                  value={
                    formik.values.etaOut
                      ? formik.values.etaOut
                      : props?.dataprops?.row?.ETAOut
                  }
                  onChange={(newValue) =>
                    formik.setFieldValue("etaOut", newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      style={{
                        marginTop: "10px",
                        marginBottom: "10px",
                        width: "100%",
                      }}
                      {...params}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
          <TextField
            id="outlined-multiline-static"
            label="Remark"
            multiline
            sx={{ width: '100%' }}
            rows={2}
            value={formik.values.remarkOut}
            onChange={(e) =>
              formik.setFieldValue("remarkOut", e.target.value)
            }
          />
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <form onSubmit={formik.handleSubmit}>
            <Button
              sx={{ width: 80 }}
              type="button"
              variant="outlined"
              style={{
                color: "#80c340",
                borderColor: "#80c340",
                marginRight: "10px",
              }}
              onClick={() => handleClose()}
            >
              close
            </Button>
            <Button
              sx={{ width: 80 }}
              type="submit"
              variant="contained"
              style={{
                background: "#80c340",
                borderColor: "#80c340",
                marginRight: "10px",
              }}
            // disabled={Submitting}
            >
              {Submitting && <CircularProgress size={22} />}
              {!Submitting && "SAVE"}
            </Button>
          </form>
        </DialogActions>
      </Dialog>
    </div>
  );
}
